<div class="form-modal">
    <div class="form-modal__body">
        <a tabindex="0" (click)="onClose()" (keypress)="onClose()" class="close-modal"
            aria-label="Close organization edit form">
            <img src="./assets/img/icons-svg/close-icon.svg" />
        </a>
        <div class="img-wrapper">
            <div class="clearfix"></div>
            <div class="title-wrapper">
                <h1>{{'dynamicForm.dynamicTitle'+apiDAta['name'] | translate: {value: apiDAta['name']} }}</h1>
            </div>
        </div>
        <div class="intro-content">
            <ng-container *ngIf="userData.organizations[0].serviceType === 1; else servicetypetwo">
                <p translate>dynamicForm.contentStudent</p>
            </ng-container>
            <ng-template #servicetypetwo>
                <ng-container *ngIf="userData.organizations[0].serviceType === 2; else servicetypethree">
                    <p translate>dynamicForm.contentEmployer</p>
                </ng-container>
            </ng-template>
            <ng-template #servicetypethree>
                <ng-container *ngIf="userData.organizations[0].serviceType === 3; else servicetypefour">
                    <p translate>dynamicForm.contentCommunity</p>
                </ng-container>
            </ng-template>
            <ng-template #servicetypefour>
                <ng-container *ngIf="userData.organizations[0].serviceType === 4; else servicetypedefault">
                    <p translate>dynamicForm.contentManagedcare</p>
                </ng-container>
            </ng-template>
            <ng-template #servicetypedefault>
                <p translate>dynamicForm.contentDefault</p>
            </ng-template>
        </div>
        <div>
            <form novalidate [formGroup]="dynamicForm" (ngSubmit)="doSave()">
                <div class="form-wrapper-80">
                    <div *ngFor="let data of formData; let i = index" style="margin-top: 15px;">
                        <div class="app-c-form-group" *ngIf="data['Type'] === 6">
                            <input
                                class="app-c-form-control"
                                type="text"
                                [formControlName]="data['Key']"
                                placeholder="{{data['Comment']}}"
                                (change)="valueChange(data, $any($event.target).value)" />
                            <div class="error-message" *ngIf="isSubmitted && dynamicForm.get(data['Key']).hasError('required')">
                                {{'dynamicForm.fieldRequired' | translate}}
                            </div>
                        </div>
                        <div class="app-c-form-group" *ngIf="data['Type'] === 8">
                            <input
                                class="app-c-form-control"
                                type="text"
                                [formControlName]="data['Key']"
                                placeholder="{{data['Comment']}}"
                                (change)="valueChange(data, $any($event.target).value)" />
                            <div class="error-message" *ngIf="isSubmitted && dynamicForm.get(data['Key']).hasError('required')">
                                {{'dynamicForm.fieldRequired' | translate}}
                            </div>
                            <div class="error-message" *ngIf="dynamicForm.get(data['Key']).hasError('notMatched')">
                                {{'dynamicForm.invalid' | translate : { minval: minval, maxval: maxval } }}
                            </div>
                        </div>

                        <div class="app-c-form-group" *ngIf="data['Type'] === 4">
                            <select
                                class="app-c-form-control"
                                [formControlName]="data['Key']"
                                aria-required="true"
                                (change)="valueChange(data, $any($event.target).value, opt)">
                                <option value="">{{data['Comment']}}</option>
                                <option *ngFor="let opt of data.options" [value]="opt">{{opt.Comment}}</option>
                            </select>
                            <div class="error-message" *ngIf="isSubmitted && dynamicForm.get(data['Key']).hasError('required')">
                                {{'dynamicForm.fieldRequired' | translate}}
                            </div>
                        </div>

                        <div class="app-c-form-group" *ngIf="data['Type'] === 5">
                            <textarea
                                class="app-c-form-control"
                                placeholder="{{data['Comment']}}"
                                [formControlName]="data['Key']"
                                aria-required="true"
                                (change)="valueChange(data, $any($event.target).value, opt)"></textarea>
                            <div class="error-message" *ngIf="isSubmitted && dynamicForm.get(data['Key']).hasError('required')">
                                {{'dynamicForm.fieldRequired' | translate}}
                            </div>
                        </div>

                        <div class="app-c-form-group radio-section" *ngIf="data['Type'] === 1">
                            <div class="survey-question-block">{{data['Comment']}}</div>
                            <label class="app-c-radio" *ngFor="let opt of data.options; let j = index">
                                <input
                                    type="radio"
                                    [formControlName]="data['Key']"
                                    [value]="opt.ID"
                                    (change)="valueChange(data, opt)" />
                                <span>{{opt.Comment}}</span>
                            </label>
                            <div class="error-message" *ngIf="isSubmitted && dynamicForm.get(data['Key']).hasError('required')">
                                {{'dynamicForm.fieldRequired' | translate}}
                            </div>
                        </div>

                        <div class="app-c-form-group" *ngIf="data['Type'] === 2">
                            <label for="active" translate>{{data['Comment']}}</label>
                            <br />
                            <label class="app-c-checkbox" *ngFor="let opt of data.options; let j = index">
                                <input
                                    type="checkbox"
                                    [formControlName]="data['Key']"
                                    [value]="opt.ID"
                                    (change)="valueChange(data, opt)" />
                                <span>{{opt.Comment}}</span>
                            </label>
                            <div class="error-message" *ngIf="isSubmitted && dynamicForm.get(data['Key']).hasError('required')">
                                {{'dynamicForm.fieldRequired' | translate}}
                            </div>
                        </div>

                        <!--Slide rand corresponding fields-->
                        <div *ngIf="data['Type'] === 7" class="nps-survey-block">
                            <div class="">
                                <div class="survey-question-block">{{data['Comment']}}</div>
                                <app-number-scale [scaleIndex]="i" [scaleOptionValues]="data.options"
                                    (onCompleted)="scaleSelectionCompleted($event)"></app-number-scale>

                                <div class="error-message" *ngIf="isSubmitted && isMainQuestionAnswered(data)">
                                    {{'dynamicForm.fieldRequired' | translate}}
                                </div>
                            </div>

                            <div>
                                <div *ngFor="let subQn of data.sub; let j = index">
                                    <div *ngIf="subQn['show']">
                                        <div *ngIf="subQn['Type'] === 5">
                                            <div class="app-c-form-group">
                                                <input
                                                    class="app-c-form-control wt-auto-demographic-age"
                                                    type="text"
                                                    [formControlName]="data['Key']"
                                                    placeholder="{{subQn['Comment']}}"
                                                    (change)="valueChange(subQn, $any($event.target).value)" />
                                            </div>
                                            <div *ngIf="isSubmitted && isValid(subQn, i)" class="error-message">
                                                {{'dynamicForm.fieldRequired' | translate}}
                                            </div>
                                        </div>

                                        <div *ngIf="subQn['Type'] === 4">
                                            <div class="app-c-form-group">
                                                <select
                                                    class="app-c-form-control wt-auto-demographic-gender"
                                                    aria-required="true"
                                                    (change)="valueChange(subQn, $any($event.target).value, opt)">
                                                    <option value="">{{subQn['Comment']}}</option>
                                                    <option *ngFor="let opt of subQn.options" [value]="opt">{{opt.Comment}}</option>
                                                </select>
                                            </div>
                                            <div *ngIf="isSubmitted && isValid(subQn, i)" class="error-message">
                                                {{'dynamicForm.fieldRequired' | translate}}
                                            </div>
                                        </div>

                                        <div *ngIf="subQn['Type'] === 6">
                                            <div class="app-c-form-group">
                                                <textarea
                                                    class="app-c-form-control"
                                                    placeholder="{{subQn['Comment']}}"
                                                    [formControlName]="data['Key']"
                                                    aria-required="true"
                                                    (change)="valueChange(subQn, $any($event.target).value, opt)"></textarea>
                                            </div>
                                            <div *ngIf="isSubmitted && isValid(subQn, i)" class="error-message">
                                                {{'dynamicForm.fieldRequired' | translate}}
                                            </div>
                                        </div>


                                        <div class="app-c-form-group radio-section" *ngIf="subQn['Type'] === 1">
                                            <div class="survey-question-block">{{data['Comment']}}</div>
                                            <label class="app-c-radio" *ngFor="let opt of subQn.options; let j = index">
                                                <input
                                                    type="radio"
                                                    [value]="opt.ID"
                                                    (change)="valueChange(subQn, opt)" />
                                                <span>{{opt.Comment}}</span>
                                            </label>
                                            <div *ngIf="isSubmitted && isValid(subQn, i)" class="error-message">
                                                {{'dynamicForm.fieldRequired' | translate}}
                                            </div>
                                        </div>

                                        <div class="app-c-form-group" *ngIf="subQn['Type'] === 2">
                                            <label for="active" translate>{{subQn['Comment']}}</label>
                                            <br />
                                            <label class="app-c-checkbox" *ngFor="let opt of subQn.options; let j = index">
                                                <input
                                                    type="checkbox"
                                                    [value]="opt.ID"
                                                    (change)="valueChange(subQn, opt)" />
                                                <span>{{opt.Comment}}</span>
                                            </label>
                                            <div *ngIf="isSubmitted && isValid(subQn, i)" class="error-message">
                                                {{'dynamicForm.fieldRequired' | translate}}
                                            </div>
                                        </div>


                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>

                </div>
            </form>
            <div class="fixed-footer">
                <a tabindex="0" class="app-c-btn app-c-btn--primary app-c-btn--curve" (click)="doSave()" (keypress)="doSave()"><span translate>dynamicForm.save</span></a>
            </div>
        </div>
    </div>
</div>
